import { BE_SERVER_ENDPOINT } from '../constants/configs';

export let currentAuthToken = null;
export let preview = false;
let externalParams = null;
let embedMode = false;

export function setAuthToken(authToken){
    currentAuthToken = authToken;
}

export function enablePreview(){
  preview = true;
}

export function getAuthToken(){
    return currentAuthToken;
}

export function isPreview(){
  return preview;
}

export function setExternalParams(params){
  externalParams = params;
}

export function updatePreviewParams(params){
  let updatedParams = params;
  if(!updatedParams){
    updatedParams = {};
  }
  if(externalParams){
    updatedParams['external-params'] = externalParams;
  }
  return updatedParams;
}

export function updateToPreviewEndpoint(endpoint){
  let urlSplit = endpoint.split(BE_SERVER_ENDPOINT);
  return urlSplit[0] + BE_SERVER_ENDPOINT + "/preview" + urlSplit[1];
}

export function enableEmbedMode() {
  embedMode = true;
}

export function isEmbedMode() {
  return embedMode;
}
